import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { toggleShowTasksSidebar } from 'actions';
import { TasksSidebar } from 'components';

class Container extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Container';

    this.handleClickTasksSidebarToggle = this.handleClickTasksSidebarToggle.bind(this);
  }

  handleClickTasksSidebarToggle() {
    this.props.toggleShowTasksSidebar();
  }

  render() {
    const { removeClassNames } = this.props;
    const children = React.Children.toArray(this.props.children);

    const LeftSidebar = children.filter((object) => {
      if(typeof object.type === 'string') return false;
      return object.type.prototype.getName ? object.type.prototype.getName().includes('SidebarLeft') : false;
    })[0];

    const otherChildren = children.filter((object) => {
      if(typeof object.type === 'string') return true;
      return object.type.prototype.getName ? !object.type.prototype.getName().includes('SidebarLeft') : true;
    });

    const { pathname } = window.location;

    const container_class_name = `${removeClassNames ? this.props.className : `content-body container-container ${this.props.className || ''}`} ${this.props.addLargeWidthPadding ? 'app-container-large-width-padding' : ''}`
    return(
      <section
        role="main"
        style={this.props.style}
        className={container_class_name}
        >
        <header className="page-header hidden-xs">
          <h2>{this.props.title}</h2>
          <div className="right-wrapper pull-right">
            {this.props.controls}
            <ol className="breadcrumbs">
              <li>
                <Link to='/'>
                  <i className="fa fa-home"></i>
                </Link>
              </li>
              {pathname && pathname.split('/').filter(p => p).map((item, idx) => {
                item = item.split('-').filter(p => p).map(p => {
                  return `${p[0].toUpperCase()}${p.slice(1,p.length)}`;
                }).join(' ');
                return <li key={`${idx}-${item}`}><span>{item}</span></li>
              })}
            </ol>
            <div
              className='sidebar-right-toggle'
              data-open='sidebar-right'
              onClick={this.handleClickTasksSidebarToggle}
              >
              <i className='fa fa-thumb-tack tasks-sidebar-toggle' />
            </div>
          </div>
        </header>
          {LeftSidebar ? (
            <section className="content-with-menu media-gallery">
              <div className="content-with-menu-container">
                {LeftSidebar}
                <div className="inner-body mg-main">
                  {otherChildren}
                </div>
              </div>
            </section>
          ) : otherChildren}
          <TasksSidebar />
      </section>
    );
  }
}

Container.propTypes = {
  title : PropTypes.string,
  style : PropTypes.object,
  className : PropTypes.string,
  controls: PropTypes.object
}

export default connect(null, { toggleShowTasksSidebar })(Container);



// WEBPACK FOOTER //
// ./src/browser/components/ui/container.js